export default {
    barnehagenavn: 'barnehagenavn',
    organisasjonsnummer: 'organisasjonsnummer',
    name: 'adminNavn',
    email: 'adminEpost',
    password: 'adminPassord',
};
